<script setup>

import {useDelayedStore} from "@/stores/delayed";
import {storeToRefs} from "pinia";
import {computed, ref, watch, watchEffect} from "vue";

const delayedStore = useDelayedStore();

const {
  isOpened,
  button,
  delay, afterHours, afterMinutes,
  dateType, atHours, atMinutes,
} = storeToRefs(delayedStore);

const {close} = delayedStore;

const afterHourInput = ref();
const afterMinuteInput = ref();
const atHourInput = ref();
const atMinuteInput = ref();

const onAfterHourFocus = event => {
  if (0 < afterHours.value.length)
    afterHourInput.value.setSelectionRange(0, afterHours.value.length);
};

const onAfterMinuteFocus = event => {
  if (0 < afterMinutes.value.length)
    afterMinuteInput.value.setSelectionRange(0, afterMinutes.value.length);
};

const onAtHourFocus = event => {
  if (0 < atHours.value.length)
    atHourInput.value.setSelectionRange(0, atHours.value.length);
};

const onAtMinuteFocus = event => {
  if (0 < atMinutes.value.length)
    atMinuteInput.value.setSelectionRange(0, atMinutes.value.length);
};

const onAfterHourInput = event => {
  if (1 < afterHours.value.length)
    afterMinuteInput.value.focus();
};

const onAfterMinuteInput = event => {
  if (1 < afterMinutes.value.length)
    confirm.value.$el.focus();
};

const onAtHourInput = event => {
  if (1 < atHours.value.length)
    atMinuteInput.value.focus();
};

const onAtMinuteInput = event => {
  if (1 < atMinutes.value.length)
    confirm.value.$el.focus();
};

watchEffect(() => {
  if (delay.value === 'after' && afterHourInput.value)
    afterHourInput.value.focus();
  else if (delay.value === 'at' && atHourInput.value)
    atHourInput.value.focus();
});

watch([delay, dateType, atHourInput], ([delay, , atHourInput]) => {
  if (delay !== 'at') return;
  atHourInput && atHourInput.focus();
});

const confirm = ref();

const onClose = () => {
  close(true);
};

</script>

<template>
  <v-dialog v-model="isOpened" max-width="400" v-if="isOpened">
    <v-card>
      <v-card-title class="text-h5">
        예약 설정
      </v-card-title>
      <v-card-text>
        <v-card
            :class="['schedule-type-card', delay === 'after' && 'selected']"
            variant="outlined"
            @click="delay = 'after'"
        >
          <v-card-text>
            <div class="d-flex align-center mb-4">
              <v-icon size="large" :color="delay === 'after' ? 'primary' : 'grey'" class="mr-3">mdi-clock-outline</v-icon>
              <div>
                <div class="text-h6" :class="[delay !== 'after' && 'text-grey']">일정 시간</div>
              </div>
            </div>

            <div class="d-flex justify-end align-center">
              <!-- Hour inputs -->
                <input
                    ref="afterHourInput"
                    :class="['time-box', delay !== 'after' && 'text-grey']"
                    maxlength="2"
                    v-model="afterHours"
                    @focusin="onAfterHourFocus"
                    @input="onAfterHourInput"
                />
              <span :class="['mx-2', delay !== 'after' && 'text-grey']">:</span>
              <!-- Minute inputs -->
                <input
                    ref="afterMinuteInput"
                    :class="['time-box', delay !== 'after' && 'text-grey']"
                    maxlength="2"
                    v-model="afterMinutes"
                    @focusin="onAfterMinuteFocus"
                    @input="onAfterMinuteInput"
                />
              <span :class="['align-self-end ml-2', delay !== 'after' && 'text-grey']">후 실행</span>
            </div>
          </v-card-text>
        </v-card>
        <v-card
            :class="['schedule-type-card mt-2', delay === 'at' && 'selected']"
            variant="outlined"
            @click="delay = 'at'"
        >
          <v-card-text>
            <div class="d-flex align-center mb-4">
              <v-icon size="large" :color="delay === 'at' ? 'primary' : 'grey'" class="mr-3">mdi-calendar-clock</v-icon>
              <div>
                <div class="text-h6" :class="[delay !== 'at' && 'text-grey']">특정 시간</div>
              </div>
            </div>
            <div class="d-flex justify-end align-center">
              <!--
              <v-card
                  :class="['schedule-date-card flex-0-0', type === 'at' && dateType === 'tomorrow' && 'selected']"
                  variant="outlined"
                  @click="type === 'at' && (dateType = 'tomorrow')"
              >
                <v-card-text class="d-flex pa-2 px-4 justify-center align-center">
                  <div class="text-h8 text-align-center" :class="[!(type === 'at' && dateType === 'tomorrow') && 'text-grey']">내일</div>
                </v-card-text>
              </v-card>
              <v-card
                  :class="['schedule-date-card flex-0-0 ml-1', type === 'at' && dateType === 'next' && 'selected']"
                  variant="outlined"
                  @click="type === 'at' && (dateType = 'next')"
              >
                <v-card-text class="d-flex pa-2 px-4 justify-center align-center">
                  <div class="text-h8 text-align-center" :class="[!(type === 'at' && dateType === 'next') && 'text-grey']">다음</div>
                </v-card-text>
              </v-card>
              <div class="d-flex flex-1-0"></div>
              -->
              <!-- Hour inputs -->
              <input
                  ref="atHourInput"
                  :class="['time-box', delay !== 'at' && 'text-grey']"
                  maxlength="2"
                  v-model="atHours"
                  @focusin="onAtHourFocus"
                  @input="onAtHourInput"
              />
              <span :class="['mx-2', delay !== 'at' && 'text-grey']">:</span>
              <!-- Minute inputs -->
              <input
                  ref="atMinuteInput"
                  :class="['time-box', delay !== 'at' && 'text-grey']"
                  maxlength="2"
                  v-model="atMinutes"
                  @focusin="onAtMinuteFocus"
                  @input="onAtMinuteInput"
              />
              <span :class="['align-self-end ml-2', delay !== 'at' && 'text-grey']">에 실행</span>
            </div>
          </v-card-text>
        </v-card>
        <v-card
            class="mt-4"
            variant="tonal"
            color="grey-darken-2"
        >
          <v-card-text>
            <div class="d-flex flex-column">
              <div class="text-h6 text-primary">{{ button.name }}</div>
              <div class="text-body-2 text-medium-emphasis">{{ button.description }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn ref="confirm" color="primary" variant="text" @click="onClose">
          예약하기
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.schedule-type-card {
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  border-color: rgba(0, 0, 0, 0.12);
}

.schedule-type-card.selected {
  border-color: rgb(var(--v-theme-primary));
  background-color: rgb(var(--v-theme-primary-container));
}

.schedule-type-card.selected .schedule-date-card {
  pointer-events: auto;
}

.schedule-type-card:not(.selected) .schedule-date-card {
  pointer-events: none;
}

.schedule-date-card {
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0.5;
  border-color: rgba(0, 0, 0, 0.12);
}

.schedule-date-card.selected {
  opacity: 1;
  pointer-events: auto;
  border-color: rgb(var(--v-theme-primary));
  background-color: rgb(var(--v-theme-primary-container));
}

.time-box {
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  font-size: 1.25rem;
  border: 1px solid #ccc;
  border-radius: 0.375rem;
}
</style>